import axios from "axios";

class FormApi {
  constructor() {

    this.api = axios.create({
      baseURL: '//',
      headers: {
        Authorization: "FIX ME",
      },
    });
  }

  async submit(formData) {
    const realFormData = new FormData();
    for (const key of Object.keys(formData)) {
      if (Array.isArray(formData[key])) {
        for (let datum of formData[key]) {
          realFormData.append(`${key}[]`, datum)
        }
      } else {
        realFormData.append(key, formData[key])
      }
    }
    return this.api.post("formProxy", realFormData);
  }
}

export default FormApi;
